import React from 'react';
import LegalDialog from './ui/LegalDialog';

const sections = [
  {
    title: '1. Acceptance of Terms',
    copy: 'By accessing and using Clear Horizons, you agree to comply with these terms. If you do not agree, please do not use our services.',
  },
  {
    title: '2. Use of Service',
    copy: 'Clear Horizons provides a platform for blind individuals to showcase their skills and connect with employers. Users agree to use the platform responsibly and lawfully.',
  },
  {
    title: '3. Privacy and Data Protection',
    copy: 'We value privacy and are committed to protecting personal information. Our privacy policy explains how information is collected, used, and protected.',
  },
  {
    title: '4. Limitation of Liability',
    copy: 'Clear Horizons is not responsible for damages, losses, or expenses arising from use of the platform.',
  },
  {
    title: '5. Modifications to Terms',
    copy: 'Clear Horizons may update these terms from time to time. Continued use of the platform constitutes acceptance of updated terms.',
  },
];

function Modal({ show, onClose }) {
  return (
    <LegalDialog
      show={show}
      onClose={onClose}
      title="Terms and Conditions"
      intro="Welcome to Clear Horizons. These terms govern access to and use of the services provided by Clear Horizons, including the website and related services."
      sections={sections}
    />
  );
}

export default Modal;
